module.exports = __webpack_public_path__ + "static/media/Vortex-4WD-OV-5480-IQ.6d46d803.png";